import { makeStyles } from "@mui/styles";

export const mainLayout = { display: "flex", margin: "0px", height: "100vh" };

export const drawerToggleHandler = {
  cursor: "pointer",
  display: "flex",
  alignItems: "start",
};

export const subscriptionBox = { display: "flex", alignItems: "center" };

export const iconBoxBackground = { background: "#002B49" };

export const expandColor = { color: "#FFAB8C" };

export const whiteColor = { color: "#FFFFFF" };

const useLayoutStyles = makeStyles(() => {
  return {
    drawerBox: {
      display: "flex",
      paddingTop: "0px !important",
      marginBottom: "0px !important",
      marginTop: "27px !important",
      "&.mobile": {
        marginTop: "0px !important",
        paddingTop: "20px !important",
      },
      "&.token": {
        marginTop: "24px !important",
        marginBottom: "11px !important",
      },
    },
    drawerHeaderBox: {
      flexGrow: "1 !important",
      flexDirection: "column",
      minHeight: "900px !important",
      margin: "0 auto !important",
      position: "relative",
      display: "flex !important",
      maxWidth: "100% !important",
      minWidth: "982px !important",
      marginTop: "9 !important",
      "&.mobile": {
        minWidth: "0px !important",
        marginTop: "40px !important",
      },
      "&.token": {
        marginTop: "0 !important",
      },
      "&.nav": {
        maxWidth: "1600px !important",
      },
    },
  };
});

export default useLayoutStyles;
